<template>
  <div class="d-flex align-center w-full z-1">
    <SysBtn :size="0" @click="dialog_filtros_ativo = ! dialog_filtros_ativo">
      <v-icon color="#777777" size="19">mdi-filter</v-icon>
      Filtros
      <span v-text="QTDE_FILTROS_APLICADOS" class="font-12 text-gray-800 ml-1" />
    </SysBtn>

    <FiltrosTelaComprasProdutosGerais v-model="dialog_filtros_ativo" />

    <ListaProdutosSilenciados class="ml-4" />

    <ConverterEmbalagem />

    <v-btn title="Mudar orientação da tela" class="ml-2" icon @click="mudarOrientacaoVisaoTela">
      <v-icon size="20">mdi-screen-rotation</v-icon>
    </v-btn>

    <v-spacer />

    <CarrinhoCompraProdutosGerais />
  </div>
</template>

<script>
import FiltrosTelaComprasProdutosGerais from "@/components/compra/ProdutosGerais/Filtros/Index";
import ConverterEmbalagem from "@/components/compra/Embalagem/ConverterEmbalagem";
import CarrinhoCompraProdutosGerais from "@/components/compra/ProdutosGerais/Carrinho/Index";
import HabilitarCompraDistribuidaPorFilial from "@/components/compra/CompraDistribuidaPorFilial/HabilitarCompraDistribuidaPorFilial";
import ListaProdutosSilenciados from "@/components/compra/ProdutosGerais/ProdutosSilenciados/ListaProdutos/Index";

export default {
  name: "BarraDeMenuPrincipal",
  components: {
    ListaProdutosSilenciados,
    HabilitarCompraDistribuidaPorFilial,
    ConverterEmbalagem,
    FiltrosTelaComprasProdutosGerais,
    CarrinhoCompraProdutosGerais,
  },
  data: () => ({
    dialog_filtros_ativo: false
  }),
  computed: {
    VISAO_VERTICAL_ATIVA: {
      get: function () {
        return this.$store.getters['CompraProdutosGerais/getVisaoVertical'];
      },
      set: function (valor) {
        localStorage.config_orientacao_vertical_tela_compras = valor ? 'S' : 'N';
        return this.$store.dispatch('CompraProdutosGerais/setVisaoVertical', valor);
      }
    },
    FILTROS_STORE() {
      return this.$store.getters['CompraProdutosGerais/getFiltros'];
    },
    QTDE_FILTROS_APLICADOS() {
      const qtde_filtros = this.FILTROS_STORE.grupos.length
        + this.FILTROS_STORE.filiais.length
        + this.FILTROS_STORE.segmentos.length
        + this.FILTROS_STORE.secoes.length
        + this.FILTROS_STORE.compradores.length
        + this.FILTROS_STORE.fornecedores.length
        + this.FILTROS_STORE.status_compra.length
        + this.FILTROS_STORE.status_produto.length
        + (this.FILTROS_STORE.pesquisa.length > 0 ? 1 : 0);

      if (qtde_filtros === 0) {
        return '';
      }

      return qtde_filtros > 1 ? `(${qtde_filtros} filtros aplicados)` : `(${qtde_filtros} filtro aplicado)`;
    }
  },
  watch: {
    'FILTROS_STORE.filiais': function () {
      if (this.FILTROS_STORE.filiais.length > 0) {
        this.desabilitarCompraPorMultifiliais();
      }
    }
  },
  methods: {
    mudarOrientacaoVisaoTela() {
      this.VISAO_VERTICAL_ATIVA = ! this.VISAO_VERTICAL_ATIVA;
    },
    desabilitarCompraPorMultifiliais() {
      this.$store.dispatch('CompraDistribuidaPorFilial/set_distribuir_por_filial', false);
      this.$store.dispatch('CompraDistribuidaPorFilial/set_considerar_estoque_grupo', true);
    }
  }
}
</script>

<style scoped>
</style>
